import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

// Used 10x across 10 files on Box
export const FlexColumnBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}) as typeof Box;

// Used 10x across 7 files on Box
export const FlexRowBox = styled(Box)({
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start',
  alignItems: 'center',
});

// Used 7x across 7 files on Box
export const SpaceBetweenBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 8,
  alignItems: 'center',
});

// Used 7x across 7 files — flex row, space-between, bottom margin 1 spacing unit (e.g. section headers)
export const SpaceBetweenMb1Box = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 8, // theme.spacing(1)
});

// Used 7x across 7 files — bare flex row, space-between only (no margin/alignItems — cf. SpaceBetweenBox)
export const SpaceBetweenRowBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
});

// Used 3x across 3 files — flex row, horizontally centered (e.g. centered button groups)
export const CenterBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
});

// Used 6x across 6 files — flex row, centered content with flexGrow:1 (TopBar search/nav area)
export const FlexCenterGrowBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  flexGrow: 1,
});
